import React from "react";
import TextField, { TextFieldProps } from "@material-ui/core/TextField";

const TextInput = (props: TextFieldProps) => {
  return <TextField type="text" size="small" margin="dense" fullWidth {...props} />;
};

export default TextInput;
